import type { ListBuilderList } from '../../../types';
import {
	createAvgPerOrderColumn,
	createBasicChartColumn,
	createFinancialMetricsColumn,
	createItemColumn,
	createItemNumberColumn,
	createPurchaseInfoColumn,
	createSixMonthComparisonColumn,
} from '../columns';

/**
 * Previously Purchased list configuration
 * Shows items the client has purchased in the past
 */
export const previouslyPurchasedList: ListBuilderList = {
	id: 'client-item-previously-purchased',
	cacheTTL: 600000,
	name: 'Previously Purchased',
	type: 'default',
	active: true,
	columns: [
		createItemColumn(),
		createItemNumberColumn(),
		createPurchaseInfoColumn(),
		createFinancialMetricsColumn(),
		createAvgPerOrderColumn(),
		createSixMonthComparisonColumn(),
		createBasicChartColumn(),
	],
	searchEnabled: true,
	searchPlaceholder: 'Search items...',
	sortOrder: 0,
};
